"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurableListLoader = void 0;
const AnonymousClient_1 = require("@juvare/platform-sdk-js/AnonymousClient");
class ConfigurableListLoader {
    constructor(app, entity) {
        this.app = app;
        this.entity = entity;
        this.configurableListClient = new AnonymousClient_1.AnonymousClient(app, entity);
    }
    loadDataList(name) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.configurableListClient
                .storageList({ filter: [{ column: 'name', op: '=', value: name }], limit: 1 })
                .then((response) => {
                if (response.total === 1) {
                    return JSON.parse(response.rows[0].columns.value);
                }
                else {
                    throw new Error('Configurable list ' + name + ' not found');
                }
            });
        });
    }
    loadDataLists(names) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.configurableListClient.storageList({ filter: [{ column: 'name', op: 'in', value: names }] }).then((response) => {
                if (response.total === names.length) {
                    return response.rows.reduce((map, list) => {
                        map[list.columns.name] = JSON.parse(list.columns.value);
                        return map;
                    }, {});
                }
                else {
                    throw new Error('Configurable list ' +
                        names.filter((name) => !response.rows.find((row) => row.columns.name === name)).join(', ') +
                        ' not found');
                }
            });
        });
    }
}
exports.ConfigurableListLoader = ConfigurableListLoader;
